var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.793 0.292893C19.1835 -0.0976309 19.8165 -0.0976311 20.207 0.292893L29.293 9.37883C29.9229 10.0085 30.9998 9.56243 31 8.6718V8.08586C31 7.53358 31.4477 7.08586 32 7.08586H34C34.5523 7.08586 35 7.53358 35 8.08586V14.6718C35.0001 14.9369 35.1055 15.1914 35.293 15.3788L38.707 18.7929C38.8946 18.9804 39 19.2347 39 19.4999V20.5859C38.9999 21.1381 38.5522 21.5859 38 21.5859H37C36.4477 21.5859 36 22.0336 36 22.5859V36.0859C35.9999 36.6381 35.5522 37.0859 35 37.0859H4C3.44777 37.0859 3.00008 36.6381 3 36.0859V22.5859C3 22.0336 2.55228 21.5859 2 21.5859H1C0.447766 21.5859 8.19081e-05 21.1381 0 20.5859V19.4999C0 19.2347 0.105432 18.9804 0.292969 18.7929L18.793 0.292893ZM19.5 14.9999C13.1487 14.9999 8.00032 18.9697 8 23.8661C8 28.7628 13.1486 32.7333 19.5 32.7333C20.995 32.7333 22.4214 32.5132 23.7324 32.1142C25.729 33.5251 25.7295 33.9999 29.083 33.9999C27.7787 32.7334 27.5125 32.2786 27.6455 30.2001C29.6396 28.6052 31 26.2568 31 23.8661C30.9997 18.9697 25.8513 14.9999 19.5 14.9999Z",
    fill: "#097FE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c1fbe35e84b71842afce079acadee1bc.svg";
export { ForwardRef as ReactComponent };